/**
 * The stopped-clock illustration from the Timed Out mock.
 *
 * Exported from Figma; the viewBox keeps the artboard's own coordinates so the
 * path data is untouched.
 *
 * @see https://www.figma.com/design/gScXgpjx0dLZrksJmSVUqo/Captcha-Error-Messaging?node-id=4-669
 */
const TimedOutIllustration = () => (
  <svg
    width="280"
    height="140"
    viewBox="580 360 280 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    focusable="false"
    style={{ maxWidth: '100%', height: 'auto' }}
  >
    <path d="M738.674 476.783H701.325V492.927H738.674V476.783Z" fill="#1D354B" />
    <path
      d="M643.188 367H796.812C800.229 367 803 369.771 803 373.188V469.595C803 473.012 800.229 475.783 796.812 475.783H643.188C639.771 475.783 637 473.012 637 469.595V373.188C637 369.771 639.771 367 643.188 367Z"
      fill="white"
      stroke="#1D354B"
      strokeWidth="2"
    />
    <path
      d="M803 464.7V469.595C803 471.236 802.348 472.809 801.188 473.97C800.027 475.13 798.453 475.782 796.812 475.782H643.188C641.547 475.782 639.973 475.13 638.812 473.97C637.652 472.809 637 471.236 637 469.595V464.7H803Z"
      fill="white"
      stroke="#1D354B"
      strokeWidth="2"
    />
    <path
      d="M719.999 473.117C721.587 473.117 722.875 471.83 722.875 470.242C722.875 468.654 721.587 467.367 719.999 467.367C718.411 467.367 717.124 468.654 717.124 470.242C717.124 471.83 718.411 473.117 719.999 473.117Z"
      fill="#1D354B"
    />
    <path
      d="M674.858 493.927H764.71C765.397 493.927 766.057 494.201 766.544 494.687C767.03 495.173 767.303 495.833 767.303 496.521V499.116H672.264V496.521L672.277 496.265C672.336 495.671 672.598 495.113 673.024 494.687C673.51 494.201 674.17 493.927 674.858 493.927Z"
      fill="white"
      stroke="#1D354B"
      strokeWidth="2"
    />
    <path
      opacity="0.4"
      d="M731.897 409C731.6 409.662 731.245 410.305 730.828 410.927C729.369 413.107 727.436 414.632 725.028 415.5C727.436 416.353 729.369 417.874 730.828 420.062C732.287 422.249 733.017 424.676 733.017 427.342V434.447H737.526V438H702V434.447H706.51V427.342C706.51 424.676 707.239 422.249 708.698 420.062C710.157 417.874 712.09 416.353 714.498 415.5C712.09 414.632 710.157 413.107 708.698 410.927C708.282 410.305 707.926 409.662 707.629 409H731.897Z"
      fill="#E55940"
    />
    <path
      d="M710.169 434.447H729.831V427.342C729.831 424.646 728.876 422.339 726.965 420.423C725.054 418.507 722.732 417.549 720 417.549C717.268 417.549 714.946 418.507 713.035 420.423C711.124 422.339 710.169 424.646 710.169 427.342V434.447ZM720 413.451C722.732 413.451 725.054 412.493 726.965 410.577C728.876 408.661 729.831 406.354 729.831 403.658V396.553H710.169V403.658C710.169 406.354 711.124 408.661 713.035 410.577C714.946 412.493 717.268 413.451 720 413.451ZM702 438V434.447H706.57V427.342C706.57 424.676 707.309 422.249 708.787 420.062C710.266 417.874 712.225 416.353 714.665 415.5C712.225 414.632 710.266 413.107 708.787 410.927C707.309 408.747 706.57 406.324 706.57 403.658V396.553H702V393H738V396.553H733.43V403.658C733.43 406.324 732.691 408.747 731.213 410.927C729.734 413.107 727.775 414.632 725.335 415.5C727.775 416.353 729.734 417.874 731.213 420.062C732.691 422.249 733.43 424.676 733.43 427.342V434.447H738V438H702Z"
      fill="#E55940"
    />
    <rect x="726.5" y="405.167" width="15.1667" height="32.5" fill="white" />
    <path
      d="M735.167 431.834C736.159 431.834 737.061 432.185 737.771 432.895C738.482 433.606 738.833 434.508 738.833 435.5C738.833 436.491 738.482 437.394 737.771 438.104C737.061 438.815 736.159 439.167 735.167 439.167C734.175 439.167 733.273 438.815 732.562 438.104C731.852 437.394 731.5 436.491 731.5 435.5C731.5 434.508 731.852 433.606 732.562 432.895C733.273 432.185 734.176 431.834 735.167 431.834ZM738.833 410.167V430.5H731.5V410.167H738.833Z"
      fill="#E55940"
      stroke="white"
      strokeWidth="3"
    />
  </svg>
)

export default TimedOutIllustration
